import { actionable } from '@github/catalyst/lib/actionable'

const exitTimeout = 400

// Set while a modal leaves without closing, i.e. it's being swapped for a new
// one (a form re-rendered with errors, via its frame or a turbo stream). The
// swap happens within one task, so the flag only needs to last until the next.
let replacingModal = false

export default actionable(class extends HTMLElement {
  connectedCallback () {
    document.body.classList.add('overflow-hidden')

    // Replacing an open modal shouldn't replay the enter animation (a flash).
    if (replacingModal) {
      this.setAttribute('data-skip-enter', '')
    }

    document.addEventListener('keyup', this.onEscKey)

    document.addEventListener('turbo:before-cache', this.close)

    if (this.dataset.closeAfterSubmit !== 'false') {
      document.addEventListener('turbo:submit-end', this.onSubmit)
    }
  }

  disconnectedCallback () {
    document.body.classList.remove('overflow-hidden')

    if (!this.classList.contains('is-closing')) {
      replacingModal = true
      setTimeout(() => { replacingModal = false })
    }

    document.removeEventListener('keyup', this.onEscKey)
    document.removeEventListener('turbo:submit-end', this.onSubmit)
    document.removeEventListener('turbo:before-cache', this.close)
  }

  onSubmit = (e) => {
    if (e.detail.success && e.detail?.formSubmission?.formElement?.dataset?.closeOnSubmit !== 'false') {
      this.close()
    }
  }

  onEscKey = (e) => {
    if (e.code === 'Escape') {
      this.close()
    }
  }

  close = (e) => {
    e?.preventDefault()

    // Page snapshots are taken right after turbo:before-cache, so leave at once.
    if (e?.type === 'turbo:before-cache') {
      this.classList.add('is-closing')
      this.remove()

      return
    }

    if (this.classList.contains('is-closing')) {
      return
    }

    // Play the exit animation (application.scss), then remove. Only popup-*
    // animations count (a spinner inside never finishes); with none, e.g. under
    // reduced motion, removal is immediate. The timer covers anything stuck.
    this.classList.add('is-closing')

    const animations = this.getAnimations({ subtree: true })
      .filter((animation) => animation.animationName?.startsWith('popup-'))
    const remove = () => this.remove()

    setTimeout(remove, exitTimeout)
    Promise.all(animations.map((animation) => animation.finished)).then(remove, remove)
  }
})
